import React, { useEffect } from 'react';
import { Check, AlertTriangle } from 'lucide-react';

export const Toast = ({ mensagem, tipo = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`fixed top-6 left-1/2 -translate-x-1/2 z-[3000] flex items-center gap-3 px-8 py-4 rounded-2xl shadow-2xl font-black text-xs tracking-widest animate-in slide-in-from-top-10 duration-300 border-2 border-white/10 ${tipo === 'success' ? 'bg-emerald-600 text-white' : 'bg-red-600 text-white'}`}>
      {tipo === 'success' ? <Check size={18} /> : <AlertTriangle size={18} />}
      {mensagem}
    </div>
  );
};